import React, { memo } from 'react'
import styled from 'styled-components'

import { CheckBox, colors, Typography } from '@microfrontends/react-components'
import { useProfileSettingStore } from '../../../../store/ProfileSetting'
import { useStore } from '../../../../store'
import { convertDateTime } from '../../../../helpers/date'
import { TagNew, TitleWrapper } from '../style.css'
import InfoIcon from '../images/InfoIcon'
import PreviewJobStatus from '../../../PreviewJobStatus'

interface IProps {
    trans: (value: any) => string
}

const Box = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`

function ProfileStatus({ trans }: IProps) {
    const { state, setState } = useProfileSettingStore()
    const store = useStore().state
    const { resumeDetail } = store

    const renderContentDate = () => {
        if (!state.isOpenToWork) return ''
        const date = new Date()
        date.setDate(date.getDate() + 30)
        // Current state when user not save yet
        const isSaved = (resumeDetail?.basicInfo?.data?.attributes?.isOpenToWork === 1) === state.isOpenToWork

        const openToWorkExpiredOn = resumeDetail?.basicInfo?.data?.attributes?.openToWorkExpiredOn ?? ''
        const expiredDate = convertDateTime(isSaved ? openToWorkExpiredOn : date, 7)

        return `${trans('The status is set until')} ${expiredDate}`
    }

    return (
        <Box>
            <TitleWrapper name='title' size='medium' color={colors.grey[20]}>
                {trans('Job-seeking status')} <TagNew name='label' size='small' color={colors.primary[40]}>{trans('New')}</TagNew>
                <PreviewJobStatus />
            </TitleWrapper>
            <Typography name='body' size='medium'>
                {trans('Select Open to work to attract more employers')}
                {'. '}
                {renderContentDate()}
            </Typography>
            <CheckBox
                label={trans('I am open to work')}
                style={{ padding: 0 }}
                state={state.isOpenToWork ? 'checked' : 'none'}
                onCheckChange={(value) => {
                    setState({
                        ...state,
                        isOpenToWork: value === 'checked'
                    })
                }}
            />
        </Box>
    )
}

export default memo(ProfileStatus)
